import "./Home.module.css";
import SiteNavigation from "@/reusable_sections/Header";
import VisualIdentity from "./sections/VisualIdentity";
import VisualAlchemy from "./sections/VisualAlchemy";
import TheMethodology from "./sections/TheMethodology";
import ServiceDetails from "./sections/ServiceDetails";
import StatisticsAndSiteScope from "./sections/StatisticsAndSiteScope";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteNavigation />
      <VisualIdentity />
      <VisualAlchemy />
      <TheMethodology />
      <ServiceDetails />
      <StatisticsAndSiteScope />
      <Footer />
    </div>;
}